import { useState as E, useRef as K, useMemo as $, useCallback as c, useEffect as k } from "react";
function H({
  user: e,
  customAttributes: t,
  websiteToken: w,
  baseUrl: d = "https://chatwoot.gigstack.io",
  hmacSecret: r,
  options: a
}) {
  const [_, f] = E(!1), l = K(0), g = 3, h = 1e3, y = $(
    () => ({
      hideMessageBubble: (a == null ? void 0 : a.hideMessageBubble) ?? !1,
      showUnreadMessagesDialog: (a == null ? void 0 : a.showUnreadMessagesDialog) ?? !0,
      position: (a == null ? void 0 : a.position) ?? "right",
      useBrowserLanguage: (a == null ? void 0 : a.useBrowserLanguage) ?? !0,
      type: (a == null ? void 0 : a.type) ?? "standard",
      darkMode: (a == null ? void 0 : a.darkMode) ?? "light",
      launcherTitle: (a == null ? void 0 : a.launcherTitle) ?? "Chat de soporte"
    }),
    [a]
  ), m = c(
    async (i) => {
      if (!r) return;
      const n = new TextEncoder(), C = n.encode(r), M = n.encode(i), S = await crypto.subtle.importKey("raw", C, { name: "HMAC", hash: "SHA-256" }, !1, ["sign"]), s = await crypto.subtle.sign("HMAC", S, M);
      return Array.from(new Uint8Array(s)).map((D) => D.toString(16).padStart(2, "0")).join("");
    },
    [r]
  ), o = c(async () => {
    if (!window.chatwootSDK) {
      console.error("SDK not available after initialization");
      return;
    }
    const i = {
      websiteToken: w,
      baseUrl: d
    };
    window.chatwootSDK.run(i);
    const n = e != null && e.uid ? await m(e.uid) : void 0;
    if (r && (e != null && e.uid) && (!n || n === ""))
      if (l.current < g) {
        l.current++, console.warn(`HMAC calculation failed, retry ${l.current} of ${g}`), setTimeout(() => {
          o();
        }, h);
        return;
      } else {
        console.error("Failed to generate valid HMAC after multiple retries.");
        return;
      }
    setTimeout(() => {
      window.$chatwoot && (l.current = 0, e != null && e.uid && (window.$chatwoot.setUser(e.uid, {
        ...e.email && { email: e.email },
        ...e.name && { name: e.name },
        ...n && { identifier_hash: n },
        ...e.company_name && { company_name: e.company_name }
      }), t && (t.billing_id || t.team_id || t.plan) && window.$chatwoot.setCustomAttributes({
        ...t.billing_id && { billing_id: t.billing_id },
        ...t.team_id && { team_id: t.team_id },
        ...t.plan && { plan: t.plan }
      }))), f(!0);
    }, h);
  }, [m, e, t, w, d, r]), u = c(() => {
    if (window.chatwootSDK) {
      o();
      return;
    }
    const i = document.createElement("script");
    i.src = `${d}/packs/js/sdk.js`, i.defer = !0, i.async = !0, i.onload = o, i.onerror = () => console.error("Failed to load Chatwoot SDK"), document.body.appendChild(i);
  }, [o, d]);
  return k(() => {
    if (r && !(e != null && e.uid)) {
      console.error("Authentication required: user is not authenticated.");
      return;
    }
    return window.chatwootSettings = y, (async () => {
      try {
        u();
      } catch (n) {
        console.error("Error in initialization:", n), console.error("Error in initialization data:", n);
      }
    })(), () => {
      window.$chatwoot && window.$chatwoot.reset();
      const n = document.querySelector('script[src*="chatwoot"]');
      n && n.remove(), delete window.chatwootSettings, delete window.chatwootSDK, f(!1);
    };
  }, [y, u, r, e]), _ && null;
}
export {
  H as SupportWidget
};
